export default {
  clientinfo: {
    ip: "",
    street: "",
    city: "",
    region: "",
    region_code: "",
    country: "",
    country_code: "",
    country_code_iso3: "",
    country_capital: "",
    country_tld: "",
    country_name: "",
    continent_code: "",
    in_eu: false,
    postal: null,
    latitude: 0,
    longitude: 0,
    timezone: "",
    utc_offset: "",
    country_calling_code: "",
    currency: "",
    currency_name: "",
    languages: "",
    country_area: 0,
    country_population: 0,
    asn: "",
    org: "",
    browser_name: "",
    browser_version: 0,
    os_name: "",
    is_mobile: !1,
    mobile_model: "",
    mobile_factory: ""
  },
  user: {
      username: "",
      password: "",
      token: "",
      loggedIn: false,
      cidade: null,
      abrvCorporacao: null
  },
  usuario: {
      codUsuario: 0,
      datCadastro: "",
      domAtivo: "",
      domGrupo: "",
      email: "",
      nomCorpUsuarios: "",
      nomUsuario: "",
      tmpOcioso: 0,
      txtLogin: "",
      txtSenha: ""
  },
}